// src/api/index.js
import axios from 'axios';

import authApi from './client';

const API_IP = process.env.REACT_APP_IP || 'localhost';
const BASE_URL = process.env.REACT_APP_API_BASE || `http://${API_IP}/api`;
const api = axios.create({ baseURL: BASE_URL, timeout: 10000 });

export const getCategories = () => api.get('/categories');

export const getProductsByCategory = async (slug, params = {}) => {
  const p = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (Array.isArray(v)) v.forEach(val => p.append(k, val));
    else if (v) p.append(k, v);
  });
  return api.get(`/categories/${slug}/products?${p.toString()}`);
};

export const getProductById = (id) => api.get(`/products/${id}`);
export const getGeneralSettings = () => authApi.get(`/settings/general?t=${Date.now()}`);